(() => {
  const root = document.getElementById('ReneeFAQ');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  // Normalize pronouns in visible text without changing URLs or markup.
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  while (walker.nextNode()) {
    const node = walker.currentNode;
    if (!node.parentElement.closest('script,style,code,pre')) node.textContent = node.textContent.replace(/\bi\b/g, 'I');
  }
  const nodes = [...root.children];
  const grid = document.createElement('div');
  grid.className = 'rr-faq-grid';
  let answer = null;
  nodes.forEach(node => {
    const text = node.textContent.trim();
    if (node.tagName === 'DETAILS') { grid.append(node); node.classList.add('rr-faq-item'); const summary = node.querySelector('summary'); if(summary) summary.classList.add('rr-faq-question'); answer = null; return; }
    const question = /^H[2-6]$/.test(node.tagName) || (text.endsWith('?') && (node.querySelector('strong') || text === text.toUpperCase()));
    if (question) {
      const details = document.createElement('details'), summary = document.createElement('summary');
      summary.textContent = (text === text.toUpperCase() ? text.charAt(0) + text.slice(1).toLowerCase() : text).replace(/\bi\b/g, 'I');
      details.className = 'rr-faq-item'; summary.className = 'rr-faq-question';
      answer = document.createElement('div'); details.append(summary, answer); grid.append(details); node.remove();
    } else if (answer) answer.append(node);
  });
  root.append(grid);
})();
